module.exports = __webpack_public_path__ + "static/media/blue-plus-icon.50b6499a.svg";